
export const BOM_LIST = 'BOM_LIST'; //get the bom list
export const CATALOG_ERROR = 'CATALOG_ERROR'; //get the bom list